<template>
    <h2>Auth success !</h2>
</template>

<script>
    export default {
        name: "AuthCheck",
        created() {
            
        }
    }
</script>

<style scoped>

</style>